<template>
    <span v-html="showDate()"></span>
</template>

<script>
    export default {
        name: 'Date',
        props: ['value','startAt','endAt'],
        data: function () {
            return {
                internalValue: '',
                months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
                days: ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche']
            }
        },
        created: function() {
            this.internalValue = this.value;
        },
        methods: {
            showDate: function(){

              if( this.startAt != null && this.endAt != null ){

                let startDate = this.$helpers.utcToLocal(this.startAt, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.startAt, this.$store.state.scope.timezone) : null
                let endDate = this.$helpers.utcToLocal(this.endAt, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.endAt, this.$store.state.scope.timezone) : null

                if( startDate.format("DD.MM.YYYY") == endDate.format("DD.MM.YYYY") ){

                  // Same day
                  return " <i class='icon icon-icon_calendar' style='margin-right: 5px;transform: translateY(3px);'></i>" +
                      this.days[startDate.isoWeekday()-1] +
                      " " + startDate.format("DD") +
                      " " + this.months[startDate.month()].toLowerCase() +
                      " " + startDate.format("YYYY") +
                      " <i class='icon icon-icon_clock' style='margin-right: 5px;margin-left: 5px;transform: translateY(3px);'></i>" +
                      startDate.format("HH:mm") +
                      " - " + endDate.format("HH:mm")
                }

                return startDate.format("DD.MM.YYYY HH:mm") + " - " + endDate.format("DD.MM.YYYY HH:mm")

              }

                return "?";
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Schedule.vue